// Adapter boundary for manuscript OT integrations.
// Keep adapter paths flat by feature, without source-specific subdirectories.

import {
    historyOT as baseHistoryOT,
    rangesState,
    rangesUpdatedEffect,
    setTrackChangesUserId,
} from "components/organisms/manuscript/overleaf/ot/historyOt";
import { reviewTrackChangesTheme } from "components/organisms/manuscript/codemirror/ranges/theme";

export function historyOT(currentDoc) {
    return [...baseHistoryOT(currentDoc), reviewTrackChangesTheme];
}

export { rangesState, rangesUpdatedEffect, setTrackChangesUserId };

export { EditorFacade, realtime } from "components/organisms/manuscript/overleaf/ot/realtime";

export { historyOTType } from "components/organisms/manuscript/overleaf/ot/shareJsHistoryOtType";
export { trackedDeletesFromState } from "components/organisms/manuscript/overleaf/ot/trackedDeletes";
